module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step2-pict01-66251ef3ccc2d07e86ba820d94361f57.png";